import { Button } from "../../../components/Shared/Button";

function MultiChoiceWidget(props) {
  return (
    <div className="EmployeeReaderWidget EmployeeReaderMultiChoiceWidget">
      {/* <h1>Multiple choice</h1> */}
      <div className="EmployeeReaderMultiChoiceWidgetQuestionContainer">
        <div className="EmployeeReaderMultiChoiceWidgetQuestion">
          {props.question || "Question not avaiable"}
        </div>
        <div className="EmployeeReaderMultiChoiceWidgetAnswers">
          {props.answers.map(({name, value}, idx) => {
            if (value.length === 0) {
              return
            }
            return (
              <div className="EmployeeReaderMultiChoiceWidgetAnswer" key={idx}>
                <input
                  type="radio" 
                  name={`${props.lesson_module_name}${props.id}`}
                  value={idx} 
                  onChange={() => {}}
                  // checked={idx === props.answer}
                />
                <label htmlFor={name}>{value}</label><br />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export { MultiChoiceWidget }
